import { IScheduleStreamContentActionPayload } from '../interfaces/schedule-stream-content.action-payload.interface';
import * as momentImported from 'moment';
const moment = momentImported;

export class CreateScheduledStreamContentCommand {
    audience: {
        id: string;
    } = { id: '' };
    posting: {
        id: string;
    } = { id: '' };
    featured_stream: {
        id: string;
    } = { id: '' };
    priority: string;
    start_date: string;
    end_date: string;

    constructor(tempTap: IScheduleStreamContentActionPayload) {
        this.audience.id = tempTap.audience.id;
        this.posting.id = tempTap.posting.id;
        this.featured_stream.id = tempTap.featuredStream.id;
        this.priority = tempTap.priority;
        this.start_date = tempTap.startDate ? moment(tempTap.startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
        this.end_date = tempTap.endDate ? moment(tempTap.endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
    }
}
